var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"height":"calc(100vh - 85px)"}},[_c('export-task',{ref:"exportTask"},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('search-bar',{on:{"search":_vm.handleSearch},model:{value:(_vm.formData),callback:function ($$v) {_vm.formData=$$v},expression:"formData"}})],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }